// extracted by mini-css-extract-plugin
module.exports = {"bgDashboardImg":"useModalImageEditor_bgDashboardImg__0Rfl7"};